import { Chip } from '@global-engineering-shared/gweb-material-global';
import { Autocomplete, Checkbox, TextField } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'components/FilterAutocomplete/components/MultipleFilters/MultipleFilters.styles';
import { Filters } from 'context/FilterProvider/types/Filters';
import { stateConstantWriter } from 'features/Status/utils/statusWriter';

type MultipleFiltersProps = {
  label: string;
  options: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<Filters>>;
  filterKey: string;
  filters: Filters;
};

const MultipleFilters = ({
  label,
  options,
  setSelectedFilters,
  filterKey,
  filters,
}: MultipleFiltersProps) => {
  const classes = useStyles();

  const onChange = (value: string[]) => {
    const updatedValue = filterKey === 'status' ? stateConstantWriter(value) : value;
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey as keyof Filters]: updatedValue,
    }));
  };

  const getDefaultValue = (): string[] => {
    return filters[filterKey as keyof Filters];
  };

  return (
    <Autocomplete
      data-testid="multipleFilters"
      key={label}
      className={classes.filterBox}
      multiple
      renderTags={(tagValue: string[], getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            label={option}
            className={classes.filterChip}
            key={index}
          />
        ))
      }
      disableCloseOnSelect
      limitTags={2}
      renderInput={(params) => (
        <TextField {...params} className={classes.renderInput} label={label} />
      )}
      options={options}
      renderOption={(option, { selected }) => (
        <React.Fragment>
          <Checkbox checked={selected} />
          {option}
        </React.Fragment>
      )}
      placeholder="All"
      onChange={(_event, value) => onChange(value as string[])}
      defaultValue={getDefaultValue()}
    />
  );
};

export default MultipleFilters;
